import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { TableComponent } from '@unilog/ng9-table';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-summary-csv',
  templateUrl: './summary-csv.component.html',
  styleUrls: ['./summary-csv.component.css']
})
export class SummaryCsvComponent implements OnInit {

   @ViewChild('tableSummary') TableSummary : TableComponent;

  
  isLoading  = false;
  dataLoaded = false;


  dateDeb: string;
  dateFin: string;

  SummarySource = {
    listBtn: [],
    dataSourceBrut: [],
    multipleSelect: false,
    api: this.generalService.api,
    showFilter: true,
    hasFooter: false,
    param: "tb_primesEmployes" // changed after intparam
  }
  
  constructor(
    public http : HttpClient,
    public generalService : GeneralService,
    private datePipe: DatePipe,
    public route : ActivatedRoute,

  ) {
    datePipe = new DatePipe('en-US');
   }

  ngOnInit(): void { 
  }

  getFormatedDate(d: Date){
    return this.datePipe.transform(d.toISOString(),'yyyyMMdd');
  }

  refreshData() { 
    var d =new Date(this.dateDeb);
    var f =new Date(this.dateFin);
       var dd= this.getFormatedDate(d)
       var df= this.getFormatedDate(f)
    this.isLoading = true;
    this.generalService.rechercheTable("API_Rendement&param=ALL," + dd + "," + df ).subscribe((data: any[]) => {
      data.forEach(element => {
        element.Realise = element.Realisé;
      });
      this.TableSummary.setDataSource(data);
      this.isLoading = false;
      this.dataLoaded = true;
    }, err => { this.isLoading = false; });
  }

}
